define('controllers/mymessage/mymessage',['app'], function (app) {
    app.controller('MyMessage', ['$q', '$scope','auiDialog','mymessageService','$rootScope','$state',
        function ($q, $scope, auiDialog,mymessageService,$rootScope,$state) {
            /* 1. 局部变量声明 */
            $scope.messageStatus = [{id:0,name:'未阅读'},{id:1,name:'已阅读'}];
            $scope.messageStatusForShow = {0:'未阅读',1:'已阅读'};
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                tabType:'messageList',
                messageQuery:{
                    searchTxt:'',
                    status:''
                },
                messageHeader:{
                    subject : {
                        id : "message_name",
                        name : "主题",
                        filterMethod : queryMessageLikeList,
                        queryMethod : queryMessageList
                    },
                    status : {
                        id : "message_status",
                        name : "状态",
                        width : 200, // 非必填参数，如果不传的话，按表头的宽度来
                        data : $scope.messageStatus,
                        queryMethod : queryMessageList
                    }
                },
                messagePagination:{currentPage: 1, itemsPerPage: 10, totalCount: 0, noItems: "No products", pagesLength: 5, onChange: queryMessageList,perPageOptions:[10,20,50]},
                messageList:null,
                messageDetail:null

            };
            /* 3. $scope函数挂载 */
            $scope.queryMessageList = queryMessageList;
            $scope.queryMessageDetail = queryMessageDetail;
            $scope.delNews = delNews;


            $rootScope.checkState($state).then(function () {
                // 刷新一级菜单栏的未读消息数
                $scope.refreshMsgNumber();
                queryMessageList();
            });


            function queryMessageLikeList(){
                var defer = $q.defer();
                var paramReq = {searchTxt : Model.messageQuery.searchTxt};
                mymessageService.queryMessageLikeList(paramReq).then(function(resp){
                	defer.resolve(resp);
                });
                return defer.promise;
            }

            /* 5. 函数声明 */
            function queryMessageList () {
            	var paramReq = {
            			offset:1 + (Model.messagePagination.currentPage - 1) * Model.messagePagination.itemsPerPage,
            			pageCount:Model.messagePagination.itemsPerPage,
            			searchTxt: Model.messageQuery.searchTxt,
            			status:Model.messageQuery.status
            	};
            	mymessageService.queryMessageList(paramReq).then(function(resp){
                    Model.messageList = resp.developerStationMsgList;
                    Model.messagePagination.totalCount = resp.totalCount;
                })
            }

            function queryMessageDetail(msgID){
            	mymessageService.queryMessageDetail(msgID).then(function(resp){
            		Model.messageDetail = resp.messageDetail;
                    Model.tabType = resp.tabType;
                    // 将List中的这一条的状态置为已读，减少接口调用次数
                    mymessageService.setReaderedIndex(msgID,Model.messageList).then(function(){
                    	$scope.refreshMsgNumber();
                    });
            	});
            }

            function delNews(msgID) {
            	mymessageService.delNews(msgID).then(function(data){
            		 if (data && data.retCode == 0) {
                         queryMessageList();
                     }
                     else {
                         auiDialog.fail("站内信删除失败。");
                     }
                     // 刷新一级菜单栏的未读消息数
                     $scope.refreshMsgNumber();
            	});
            }
            
        }]
    );
});

